import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAzelaicAcidGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.25 38.5H27.74L39.8 25.25c.2-.22.25-.54.13-.81a.725.725 0 0 0-.68-.44H19.47L16.13 8.59A.75.75 0 0 0 15.4 8a.75.75 0 0 0-.73.59L11.33 24H8.75a.749.749 0 1 0 0 1.5H11L8.06 39.09c-.09.41.17.8.57.89.41.08.8-.17.89-.57l3.02-13.91h5.72l3.02 13.91c.08.35.39.59.73.59a.75.75 0 0 0 .73-.91L19.8 25.5h17.75L25.49 38.74a.753.753 0 0 0 .56 1.26h13.21c.41 0 .75-.34.75-.75s-.35-.75-.76-.75ZM12.86 24l2.54-11.71L17.94 24h-5.08Z",
    fill: "currentColor"
  }));
}

export { SvgAzelaicAcidGlyphSecondary as default };
